import apiV2Service from '../api/api-v2.service';
import {CellValueOverride} from '../campaigns/copilot/skills/campaignSetupSkill/excelImport/excelImport.types';
import {toCampaignSignal} from './excelToCampaign.dataConverters';
import {CampaignSignal, RemoteCampaignSignal} from './excelToCampaign.types';

const basePath = 'ExcelToCampaign';

async function getCampaignSignals({
  campaignId,
  versionId,
}: {
  campaignId: number;
  versionId: number;
}): Promise<CampaignSignal[]> {
  const {data: remoteCampaignSignals} = await apiV2Service.executeGetRequest<
    RemoteCampaignSignal[]
  >(`${basePath}/campaign/${campaignId}/version/${versionId}/GetSignals`);

  return remoteCampaignSignals.map(toCampaignSignal);
}

async function createCampaign({
  campaignId,
  versionId,
  excelFileKey,
  worksheetIndex,
  headerIndexToSignalKeyMapping,
  headerRowIndex,
  headerColumnIndex,
  cellValueOverrides,
}: {
  campaignId: number;
  versionId: number;
  excelFileKey: string;
  worksheetIndex: number;
  headerIndexToSignalKeyMapping: Record<number, string | null>;
  headerRowIndex: number;
  headerColumnIndex: number;
  cellValueOverrides: CellValueOverride[];
}) {
  await apiV2Service.executePostRequest(
    `${basePath}/campaign/${campaignId}/version/${versionId}/CreateCampaign`,
    {},
    {
      s3FilePath: excelFileKey,
      worksheetIndex,
      headerIndexToSignalKeyMapping,
      headerRowIndex,
      headerColumnIndex,
      cellValueOverrides,
    },
  );
}

const excelToCampaignApi = {
  getCampaignSignals,
  createCampaign,
};

export default excelToCampaignApi;
